
import FormInput2 from '@/components/forms/FormInput2.vue'
import { applyPromoCode } from '@/helpers/PromoCodes'
import { promoCodeErrorMessage } from '@/helpers/PromoCodesHelper'
import { reportFormValidity } from '@/helpers/Validation'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ValidationError from '@/errors/ValidationError'

// TODO Merge/deduplicate with <CodeModal> component.
@Component({
  name: 'PromoCodesModal',
  components: { FormInput2 },
})
export default class extends Vue {
  @Prop({ default: false })
  submitDisabled: boolean

  readonly minLength = 2

  rawValue: string = ''
  applying: boolean = false
  error: string | null = null

  get value() {
    return this.rawValue.trim()
  }

  apply() {
    this.applying = true
    this.error = null

    reportFormValidity(this.$refs.form as HTMLFormElement)
      .then(() => applyPromoCode(this.value))
      .then(() => {
        this.rawValue = ''
        this.$modals.close()
      })
      .catch((error) => {
        // Prevent showing validation message in two places
        if (error instanceof ValidationError) return

        const formInput = this.$refs.input as Vue
        this.error = promoCodeErrorMessage(
          this.value,
          error,
          formInput.$el.querySelector('input') as HTMLInputElement,
        )

        if (this.error === this.$t('applyPromoCodes.unknownErrorMessage')) {
          throw error
        }
      })
      .finally(() => {
        this.applying = false
      })
  }
}
